let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a55gv")).then(() => parcelRequire('9kF6f'));